<template>
  <section>
    <qx-card :title="title" class="detail" v-loading="loading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
    </qx-card>
  </section>
</template>
<script>
import {
  getVehicleMaintenanceRecord,
} from 'api/car';
export default {
  components: {
  },
  data () {
    return {
      title: '查看保养信息',
      loading: false,
      detailData: {
        base: {
          label: '车辆信息',
          tableData: {
            title: [
              {
                prop: 'plateNumber',
                label: '车牌号码',
              },
              {
                prop: 'orgName',
                label: '车辆归属',
              },
              {
                prop: 'licenceTypeName',
                label: '车辆类型',
              },
              {
                prop: 'vehicleOwnerShipName',
                label: '车辆性质',
              },
              {
                prop: 'brandModelName',
                label: '品牌名称',
              },
              {
                prop: 'vehicleLengthName',
                label: '车长',
              },
            ],
            data: {},
            approveData: {},
          },
        },
        info: {
          label: '保养信息',
          tableData: {
            title: [
              {
                prop: 'maintenanceDate',
                label: '保养日期',
              },
              {
                prop: 'drivingDistanceDouble',
                label: '行驶里程',
              },
              {
                prop: 'maintenanceProject',
                label: '保养项目',
              },
              {
                prop: 'amountDouble',
                label: '金额（元）',
              },
              {
                prop: 'serviceSite',
                label: '服务站点',
              },
              {
                prop: 'remark',
                label: '备注',
              },
              {
                prop: 'maintenancePersonnel',
                label: '保养人员',
              },
              // {
              //   prop: 'nextMaintenanceDate',
              //   label: '下次保养日期',
              // },
              // {
              //   prop: 'mileageForNextMaintenanceDouble',
              //   label: '下次保养里程数',
              // },
            ],
            data: {},
            approveData: {},
          },
        },
      },
    };
  },
  watch: {
    '$route.query.id': function () {
      // 监听id来刷新页面，因为会出现多个查看详情的tab，用的都是同一个页面，所以需要监听id来回请求获取当前id的数据
      this.getData();
    },
  },
  methods: {
    async getData () {
      // 遇到这两个URL就阻止页面刷新
      if (this.$route.path !== '/manage/car/maintain/maintenance/detail') {
        return;
      }
      this.loading = true;
      const detailRes = await getVehicleMaintenanceRecord({
        id: this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {

        if (detailRes.vehicle) {
          // 处理数据
          this.detailData.base.tableData.data = detailRes.vehicle;
          this.detailData.info.tableData.data = detailRes;
          if (detailRes.vehicle.maintainMethod === 1) {
            if (this.detailData.info.tableData.title.find((item) => item.prop !== 'nextMaintenanceDate')) {
              this.detailData.info.tableData.title.push({
                label: '下次保养日期',
                prop: 'nextMaintenanceDate',
              });
            }
          } else {
            if (this.detailData.info.tableData.title.find((item) => item.prop !== 'mileageForNextMaintenanceDouble')) {

              this.detailData.info.tableData.title.push({
                label: '下次保养里程数',
                prop: 'mileageForNextMaintenanceDouble',
              });
            }
          }
        } else {
          if (this.detailData.info.tableData.title.find((item) => item.prop !== 'nextMaintenanceDate')) {
            this.detailData.info.tableData.title.push({
              label: '下次保养日期',
              prop: 'nextMaintenanceDate',
            });
          }
          this.$message({
            type: 'error',
            message: '车辆不存在！',
          });
        }

      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>
<style>
</style>
